// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1LzeqvAYx26JegPdc7QhIY","row":"_2qBS2kW0Qs-FOVekv8-GYo"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Benefits/styles.scss
 ** module id = 471
 ** module chunks = 0
 **/